import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useOutofPocketPatientPaySchedule from "./hooks/useOutofPocketPatientPaySchedule";

const OutofPocketPatientPaySchedule = () => {
  const patientPayScheduleData = useOutofPocketPatientPaySchedule();

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={patientPayScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {patientPayScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {patientPayScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={patientPayScheduleData.formFields}
        dropdownValues={patientPayScheduleData.dropdownValues}
        paramsData={patientPayScheduleData.paramsData}
        updataParamData={patientPayScheduleData.updateParamData}
      />
      <ButtonsSection ctaButtons={patientPayScheduleData.ctaButtons} />
      <DisplayTable
        data={patientPayScheduleData.data}
        parmKey={patientPayScheduleData.parmKey}
        menuOptions={patientPayScheduleData.menuOptions}
        tableHeaders={patientPayScheduleData.columnDef}
        setRowData={patientPayScheduleData.setRowData}
        selectedPriceSchedules={patientPayScheduleData.selectedRows}
        setSelectedPriceSchedules={patientPayScheduleData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={patientPayScheduleData.first}
          rows={patientPayScheduleData.rows}
          totalRecords={patientPayScheduleData.totalRecords}
          currentPage={patientPayScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={patientPayScheduleData.onPageChange}
        />
      </div>
      {patientPayScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={patientPayScheduleData.isConfirmationModalOpen}
          onRequestClose={patientPayScheduleData.closeConfirmationModal}
          onBack={patientPayScheduleData.closeConfirmationModal}
          onSave={patientPayScheduleData.inActivatePatientPaySchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={patientPayScheduleData.setSelectedOption}
        />
      )}
      {patientPayScheduleData.isInactiveConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={patientPayScheduleData.isInactiveConfirmationModalOpen}
          onRequestClose={patientPayScheduleData.closeInactiveConfirmationModal}
          onBack={patientPayScheduleData.closeInactiveConfirmationModal}
          onSave={patientPayScheduleData.inActivatePatientPaySchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={patientPayScheduleData.setInactiveSelectedOption}
        />
      )}
    </div>
  );
};

export default OutofPocketPatientPaySchedule;
